import React, { useState, useEffect } from "react";
import { Select } from "../Helper/Select";
import MultiSelectCheckbox from "../Helper/MultiSelectCheckbox";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { SaveIcon, UserIcon, UsersIcon } from "../Helper/Icons";
import { LoaderScreen } from "../../components/LoaderScreen";

/**
 * ReasignarAuditorModal
 *
 * Props:
 *   open             — bool
 *   onClose          — fn()
 *   folio        — folio
 *   listadoAuditores — [{ value, label }]
 *   listadoEmpleados — [{ value, label }]
 */
export const ReasignarAuditorModal = ({
    open,
    onClose,
    folio,
    listadoAuditores = [],
    listadoEmpleados = [],
    onActualizar,
}) => {
    const [auditor, setAuditor] = useState("");
    const [auditoresAd, setAuditoresAd] = useState("");
    const [loading, setLoading] = useState(false);

    // Inicializar con los valores actuales del registro
    useEffect(() => {
        if (folio !== null && folio !== "" && folio !== undefined) {
            setLoading(true);
            request
                .get(`ProgramarInventario/ListadoAuditores?folio=${folio}`)
                .then((result) => {
                    setLoading(false);

                    setAuditor(Number(result.id_auditor_ppal))
                    setAuditoresAd(result.auditores_Ad)
                })
                .catch((error) => {
                    Swal.fire("RESIGNAR AUDITORES", JSON.stringify(error), "error");
                })
                .finally(() => setLoading(false));
        }
    }, [open, folio]);

    if (!open) return null;


    const handleGuardar = () => {
        // Validaciones de campos vacíos

        if (!auditor) {
            Swal.fire("RESIGNAR AUDITORES", "Debe seleccionar un auditor principal", "warning");
            return;
        }

        if (!auditoresAd || auditoresAd.length === 0) {
            Swal.fire("RESIGNAR AUDITORES", "Debe seleccionar al menos un auditor adicional", "warning");
            return;
        }

        setLoading(true);

        const post = {
            folio: folio,
            id_auditor_ppal: auditor,
            Auditores_Ad: auditoresAd,
        }

        request
            .post("ProgramarInventario/GuardarReasignacion", post)
            .then(async (result) => {
                setLoading(false);

                if (result.resultado === 1) {
                    await Swal.fire(
                        "RESIGNAR AUDITORES",
                        result.mensaje,
                        "error"
                    );
                }
                else {
                    await Swal.fire(
                        "RESIGNAR AUDITORES",
                        "Reasignación Registrada con exito",
                        "success"
                    );
                    onActualizar?.();
                    onClose()
                }
            })
            .catch((error) => {
                setLoading(false);
                Swal.fire("PROGRAMAR INVENTARIO", JSON.stringify(error), "error");
            });
    };

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) onClose?.();
    };

    return (
        <div className="ram-backdrop" onClick={handleBackdropClick}>
            <PlantillaScreen
                titulo={"Reasignar auditores"}
                className={"ram-modal"}
            >
                <button className="ram-close" onClick={onClose} type="button">
                    X
                </button>
                <LoaderScreen loader={loading} />

                {/* ── Body ── */}
                <div className="ram-body">

                    {/* Auditor principal */}
                    <div className="ram-field">
                        <div className="ram-field__icon">
                            <UserIcon />
                        </div>
                        <div className="ram-field__content">
                            <Select
                                label="Auditor responsable"
                                options={listadoAuditores}
                                value={auditor}
                                onChange={setAuditor}
                                placeholder="Seleccione un auditor"
                            />
                        </div>
                    </div>

                    {/* Auditores adicionales */}
                    <div className="ram-field">
                        <div className="ram-field__icon">
                            <UsersIcon />
                        </div>
                        <div className="ram-field__content">
                            <MultiSelectCheckbox
                                label="Auditores adicionales"
                                options={listadoEmpleados}
                                value={auditoresAd}
                                onChange={setAuditoresAd}
                                placeholder="Seleccione auditores adicionales"
                            />
                        </div>
                    </div>

                </div>

                {/* ── Footer ── */}
                <div className="ram-footer">
                    <button
                        type="button"
                        className="ram-btn ram-btn--primary"
                        onClick={handleGuardar}
                        disabled={loading || !auditor}
                    >
                        {loading ? (
                            <span className="ram-btn__spinner" />
                        ) : (
                            <SaveIcon />
                        )}
                        {loading ? "Guardando..." : "Guardar"}
                    </button>
                </div>

            </PlantillaScreen>
        </div>

    );
};

export default ReasignarAuditorModal;
